import { render, staticRenderFns } from "./EstanteList.vue?vue&type=template&id=1e0e6fcf&"
import script from "./EstanteList.vue?vue&type=script&lang=js&"
export * from "./EstanteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports